<unity-outside-container>
  <kendo-stacklayout orientation="vertical" class="outside-form" [gap]="layoutGap.rows!">
    @if (loading) {
      <h5>Logging you in...</h5>
      <kendo-loader type="infinite-spinner" size="medium" themeColor="info" />
    } @else if (!bypassed) {
      @if ($hasNoValidAgencies()) {
        <h5>You do not have approved access to any business partner data.</h5>
        <span>If this is unexpected, please contact your administrator for more information.</span>
      } @else {
        @let currentAgencyRole = $currentAgencyRole();
        <kendo-label text="Select Business Partner:">
          <kendo-dropdownlist
            textField="agency_name"
            valueField="agency_id"
            [data]="$validAgencyRoles() | sort"
            [valuePrimitive]="true"
            (selectionChange)="selectionChange($event)" />
        </kendo-label>
        <button type="button" kendoButton themeColor="primary" routerLink="/" [disabled]="!currentAgencyRole">Proceed</button>
      }
      <button type="button" kendoButton themeColor="tertiary" routerLink="/login" (click)="onBack()">Back to Login</button>
    }
  </kendo-stacklayout>
</unity-outside-container>
